import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {OnlineFormSummaryModel} from '../onlineFormSummary.model';
import {Injectable} from '@angular/core';
import {FormSummaryConverter} from '../../../../../form/form/api/entity/converter/formSummary.converter';
import {OnlineFormFormDefinitionSummaryConverter} from '../../../../definition/api/entity/converter/onlineFormFormDefinitionSummary.converter';
import {
    WorkflowTaskSummaryConverter
} from "../../../../../workflow/task/api/model/common/converter/workflowTaskSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class OnlineFormSummaryConverter extends HttpModelConverter<OnlineFormSummaryModel> {

    constructor(private formSummaryConverter: FormSummaryConverter,
                private onlineFormFormDefinitionSummaryConverter: OnlineFormFormDefinitionSummaryConverter,
                private workflowTaskSummaryConverter: WorkflowTaskSummaryConverter) {
        super();
    }

    protected createInstance(): OnlineFormSummaryModel {
        return new OnlineFormSummaryModel();
    }

    protected enrichObject(result: OnlineFormSummaryModel, src: OnlineFormSummaryModel) {
        result.form = this.formSummaryConverter.convert(src.form);
        result.onlineFormDefinition = this.onlineFormFormDefinitionSummaryConverter.convert(src.onlineFormDefinition);
        result.workflowTasks = this.workflowTaskSummaryConverter.convertFromArray(src.workflowTasks);
    }
}
